import { useNavigate } from 'react-router';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpDisableGoogleIntegration = () => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = () => {
        const { exec, abort } = userApi.disableGoogleIntegration({
            onSuccess: _ => {
                toastHandler.push('success', t('googleIntegration.disconnectTitle'), t('googleIntegration.disconnectSuccess'));
                navigate('/integrations');
            },
            onError: () => {
                toastHandler.push('error', t('googleIntegration.disconnectTitle'), t('googleIntegration.disconnectError'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDisableGoogleIntegration;
